import { useTranslation } from 'react-i18next';

// Import components
import { ModalForm } from 'components/elements';
import ParentalControlFields from './parental_control_fields/ParentalControlFields';
import { ModalCloseButton } from 'components/views/offer_configurator/components/common/modals/components/ModalCloseButton';

// Import styles
import { AntModalStyled, ModalContent, StyledTitle } from 'components/views/offer_configurator/components/common/modals/styles';

// Import types
import type { PinValidation, RatingValidation } from './parental_control_fields/validation';
import type { ParentalToggleParams } from 'types/views/parental_control';

type Params = {
	on: boolean;
	isEnabled: boolean;
	initialValues: { pin?: string; rating?: number };
	validation: PinValidation | RatingValidation;
	submitAction: (params: ParentalToggleParams) => void;
	toggle: VoidFunction;
};

const ParentalControlModal = ({ on, isEnabled, initialValues, validation, submitAction, toggle }: Params) => {
	const { t } = useTranslation();

	const title = isEnabled ? t('parental_control_title') : t('parental_control_title_not_enable');

	return (
		<AntModalStyled visible={on} closable={false} footer={null} centered>
			<ModalCloseButton closeModal={toggle} />
			<ModalContent gap={3.6}>
				<StyledTitle>{title}</StyledTitle>
				<ModalForm
					initialValues={initialValues}
					submitAction={submitAction}
					type="parental_control"
					translation="parental_control_error_message"
					isOpen={on}
					closeModal={toggle}
					validation={validation}
					isEnabled={isEnabled}
				>
					{({ isSubmitting }) => <ParentalControlFields isEnabled={isEnabled} isSubmitting={isSubmitting} />}
				</ModalForm>
			</ModalContent>
		</AntModalStyled>
	);
};

export default ParentalControlModal;
